<template>
  <div class="list-container">
    <el-row v-for="item in list" :key="item.id" class="resumeItem">
      <el-col :lg="1" :sm="1" :xs="1">
        <el-row>
          <div class="contentBox">
            <el-checkbox v-model="item.selected"></el-checkbox>
          </div>
        </el-row>
      </el-col>
      <el-col :lg="19" :sm="15" :xs="15">
        <el-row>
          <el-col :lg="2" :sm="12" :xs="12">{{ item.name }}</el-col>
          <el-col :lg="3" :sm="12" :xs="12">{{ item.postName }}</el-col>
          <el-col :lg="2" :sm="12" :xs="12">{{
            formatterPostType(item.postType)
          }}</el-col>
          <el-col :lg="2" :sm="12" :xs="12">{{
            formatterSendDate(item.sendDate)
          }}</el-col>
          <el-col :lg="2" :sm="12" :xs="12">{{
            formatterSex(item.sex)
          }}</el-col>
          <el-col :lg="2" :sm="12" :xs="12">{{ item.age }}岁</el-col>
          <el-col :lg="2" :sm="12" :xs="12">{{
            formatterPoliticallyState(item.politicallyState)
          }}</el-col>
          <el-col :lg="2" :sm="12" :xs="12">{{ item.phase }}</el-col>
          <el-col :lg="2" :sm="12" :xs="12">{{ item.studyField }}</el-col>
          <el-col :lg="3" :sm="12" :xs="12">{{ item.university }}</el-col>
        </el-row>
      </el-col>
      <el-col :lg="2" :sm="4" :xs="4">
        <span v-if="item.status == 'waiting'" class="waiting"
          ><zr-icon icon="clock"></zr-icon> 等待审核</span
        >
        <span v-if="item.status == 'pass'" class="pass"
          ><zr-icon icon="star"></zr-icon> 已通过</span
        >
        <span v-if="item.status == 'notPass'" class="notPass"
          ><zr-icon icon="hands-helping"></zr-icon> 未通过</span
        >
        <span v-if="item.status == 'primarySelect'" class="primarySelect"
          ><zr-icon icon="star-half-alt"></zr-icon> 通过初选</span
        >
      </el-col>
      <el-col :lg="2" :sm="4" :xs="4">
        <el-button type="text" @click="handleDownPdf(item)">下载pdf </el-button>
        <el-button type="text" @click="handleDownWord(item)"
          >下载word
        </el-button>
      </el-col>
    </el-row>
    <el-row><div class="rowLine"></div></el-row>
  </div>
</template>

<script>
import commFormat from "zr-util/src/utils/comm/commFormat";

export default {
  name: "ResumeList",
  props: {
    data: {
      type: Array,
      default() {
        return [];
      },
      require: true,
    },
    basicDatas: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.list = this.data.map((value) => {
      value.selected = undefined;
      return value;
    });
  },
  methods: {
    handleDownPdf() {},
    handleDownWord() {},
    formatterSex(value) {
      if (value == "female") {
        return "女";
      } else {
        return "男";
      }
    },
    formatterPoliticallyState(value) {
      if (value === "partyMember") {
        return "中共党员";
      } else if (value === "中共预备党员") {
        return "中共预备党员";
      } else if (value === "共青团员") {
        return "共青团员";
      } else if (value === "民革会员") {
        return "民革会员";
      } else if (value === "民盟盟员") {
        return "民盟盟员";
      } else if (value === "民建会员") {
        return "民建会员";
      } else if (value === "民进会员") {
        return "民进会员";
      } else if (value === "农工党党员") {
        return "农工党党员";
      } else if (value === "致公党党员") {
        return "致公党党员";
      } else if (value === "九三学社社员") {
        return "九三学社社员";
      } else if (value === "台盟盟员") {
        return "台盟盟员";
      } else if (value === "无党派民主人士") {
        return "无党派民主人士";
      } else if (value === "其他") {
        return "其他";
      } else {
        return "群众";
      }
    },
    formatterPostType(value) {
      if (this.basicDatas && this.basicDatas.length > 0) {
        for (let i = 0, len = this.basicDatas.length; i < len; i++) {
          if (value == this.basicDatas[i].code) {
            return this.basicDatas[i].name;
          }
        }
      }
      return value;
    },
    formatterSendDate(value) {
      if (typeof value == "string") {
        return value.substring(0, 10);
      } else {
        return commFormat.formatDate(value, "yyyy-MM-dd");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.list-container {
  width: 100%;
  min-height: 600px;
  margin: 10px 10px;

  .resumeItem {
    //min-height: 80px;
  }
}

.resumeItem:nth-child(odd) {
  background-color: #fafafa;
}

.resumeItem:nth-child(even) {
  background-color: #ffffff;
}

@mixin row-line {
  content: " ";
  height: 1px;
  width: 100%;
  background-color: #ebeef5;
}

.contentBox {
  height: 100%;
  width: 100%;
}

.resumeItem:before {
  @include row-line;
}

.rowLine {
  @include row-line;
}

.waiting {
  color: $base-font-color;
}
.pass {
  color: $base-color-green;
}
.notPass {
  color: $base-color-red;
}
.primarySelect {
  color: $base-color-blue;
}
</style>
